(function(){
  'use strict';
  if (window.DSDGMOR && window.DSDGMOR.version) return;

  var VERSION = 'p11dz600-gmor-message-autoplay-20260911-r1';
  var SOURCE = 'DSD_THEME_v26_P7r_ios_safe_area_modal_fix.zip';
  var videos = new Map();
  var registered = new WeakSet();
  var observer = null;
  var mutationObserver = null;
  var activeVideo = null;
  var activeOwner = '';
  var mediaUnlocked = false;
  var modalOwner = '';
  var booted = false;
  var pendingAutoplayFrame = null;
  var pendingScanTimer = null;
  var pendingViewportTimer = null;
  var lastAutoplayAttempt = new WeakMap();
  var muteWriteSuppressedUntil = new WeakMap();
  var userGestureState = new WeakMap();
  var manualPauseState = new WeakMap();
  var programmaticPauseUntil = new WeakMap();
  var modalResumeCandidate = null;
  var modalResumeWasPlaying = false;
  var VIDEO_MUTED_KEY = 'dsd.video.muted.v1';
  var AUTOPLAY_COOLDOWN_MS = 350;
  var SCAN_DEBOUNCE_MS = 80;
  var VIEWPORT_DEBOUNCE_MS = 120;

  function qsa(selector, root){
    try { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
    catch(e){ return []; }
  }

  function claimRuntime(){
    window.DSDRuntimeRegistry = window.DSDRuntimeRegistry || {};
    window.DSDRuntimeRegistry.gmor = {
      version: VERSION,
      owner: 'GlobalMediaOwnershipRuntime',
      recoveredFrom: SOURCE,
      canonical: true,
      owns: ['feed-video', 'story-video', 'modal-video', 'wasabi-video', 'viewport-media', 'audio-unlock']
    };
    if (window.DSDRegistry && typeof window.DSDRegistry.claim === 'function') {
      try { window.DSDRegistry.claim('gmor', window.DSDRuntimeRegistry.gmor); } catch(e){}
    }
    window.initializeVideoEvents = function(){ return false; };
    window.initVideoTracking = function(){ return false; };
    writeDomState();
  }

  function surfaceFor(video, meta){
    if (meta && meta.surface) return meta.surface;
    if (video.closest('.dsd-msg384__message-media, [data-dsd-msg384-message-history]')) return 'message';
    if (isOverlayMedia(video)) return 'modal-viewer';
    if (video.closest('[data-dsd-view-story], .dsd-story385__story, .dsd-story385__canvas')) return 'story';
    if (video.closest('.dsd-post-card')) return 'feed';
    if (video.closest('[data-dsd-community-shell]')) return 'community';
    return 'social';
  }

  function ownerFor(video, meta){
    if (meta && meta.owner) return meta.owner;
    return video.getAttribute('data-dsd-media-owner') || 'GlobalMediaOwnershipRuntime';
  }

  var OVERLAY_SELECTOR = '[data-dsd-modal],[role="dialog"],.dsd-modal,.dsd-immersive-overlay,[data-dsd-post-drawer],[data-dsd-message-drawer],.dsd-msg384__conversation,[data-dsd-profile-modal-layer],[data-dsd-story-composer-layer],[data-dsd-global-post-composer-layer],[data-dsd-universal-search-layer],[data-dsd-report-modal-layer]';

  function isOverlayMedia(video){
    return !!(video && video.closest && video.closest(OVERLAY_SELECTOR));
  }

  function isManualPaused(video){ return !!(video && manualPauseState.get(video)); }

  function drawerVideoKind(video){
    if (!video) return '';
    if (video.closest('.dsd-post-drawer__post-media')) return 'preview';
    if (video.closest('.dsd-launch-comment-media')) return 'comments';
    return '';
  }

  function commentDrawerPriority(){
    return document.documentElement.getAttribute('data-dsd-comment-video-priority') || 'preview';
  }

  function setCommentDrawerPriority(priority){
    priority = priority === 'comments' ? 'comments' : 'preview';
    document.documentElement.setAttribute('data-dsd-comment-video-priority', priority);
    if (activeVideo && !autoplayAllowed(activeVideo)) pause(activeVideo, 'comment-drawer-priority-' + priority);
    requestAutoplay();
    return priority;
  }

  function clearCommentDrawerPriority(){
    document.documentElement.removeAttribute('data-dsd-comment-video-priority');
  }

  function autoplayAllowed(video){
    if (video && video.closest && video.closest('[data-dsd-message-view-once="true"],[data-dsd-message-view-once-revealed="true"]')) return false;
    if (!document.documentElement.classList.contains('dsd-post-drawer-open')) return true;
    var kind = drawerVideoKind(video);
    if (!kind) return false;
    return kind === commentDrawerPriority();
  }

  function mutedPreference(){
    try {
      var saved = localStorage.getItem(VIDEO_MUTED_KEY);
      return saved == null ? true : saved !== 'false';
    } catch(e){ return true; }
  }

  function applyMutePreference(video, muted){
    if (!video) return;
    muteWriteSuppressedUntil.set(video, Date.now() + 300);
    video.muted = !!muted;
    video.defaultMuted = !!muted;
    if (muted) video.setAttribute('muted', '');
    else video.removeAttribute('muted');
  }

  function setMutedPreference(muted, source){
    try { localStorage.setItem(VIDEO_MUTED_KEY, muted ? 'true' : 'false'); } catch(e){}
    videos.forEach(function(meta, video){ if (video !== source) applyMutePreference(video, muted); });
    document.dispatchEvent(new CustomEvent('dsd:gmor:preference-changed', { detail: { muted: !!muted } }));
  }

  function normalize(video, meta){
    video.setAttribute('data-dsd-gmor-video', 'true');
    video.setAttribute('data-dsd-media-surface', surfaceFor(video, meta));
    video.setAttribute('data-dsd-media-owner', ownerFor(video, meta));
    if (meta && meta.mediaId) video.setAttribute('data-dsd-media-id', meta.mediaId);
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    applyMutePreference(video, mutedPreference());
    if (!video.getAttribute('preload')) video.preload = 'metadata';
  }

  function safePlay(video, muted){
    if (!video || !video.isConnected) return Promise.resolve(false);
    if (!autoplayAllowed(video)) return Promise.resolve(false);
    if (typeof muted === 'boolean') {
      applyMutePreference(video, muted);
    }
    var attempt;
    try { attempt = video.play(); } catch(e){ return Promise.resolve(false); }
    if (attempt && typeof attempt.then === 'function') {
      return attempt.then(function(){ return true; }).catch(function(){ return false; });
    }
    return Promise.resolve(true);
  }

  function pause(video, reason){
    if (!video) return;
    programmaticPauseUntil.set(video, Date.now() + 150);
    try { video.pause(); } catch(e){}
    applyMutePreference(video, mutedPreference());
    video.classList.remove('dsd-gmor-active');
    video.setAttribute('data-dsd-gmor-state', reason || 'paused');
    if (activeVideo === video) {
      activeVideo = null;
      activeOwner = '';
    }
    writeDomState();
  }

  function setActive(video, meta){
    if (!video) return Promise.resolve(false);
    if (!autoplayAllowed(video)) return Promise.resolve(false);
    normalize(video, meta);
    var owner = ownerFor(video, meta);
    if (activeVideo && activeVideo !== video) pause(activeVideo, 'released-by-' + owner);
    activeVideo = video;
    activeOwner = owner;
    video.classList.add('dsd-gmor-active');
    video.setAttribute('data-dsd-gmor-state', 'active');
    document.dispatchEvent(new CustomEvent('dsd:gmor:owner-changed', { detail: snapshot() }));
    writeDomState();
    return Promise.resolve(true);
  }

  function isVisible(video){
    if (!video || !video.isConnected) return false;
    if (!autoplayAllowed(video)) return false;
    if (modalOwner && !isOverlayMedia(video)) return false;
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    var vw = window.innerWidth || document.documentElement.clientWidth || 1;
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var x = Math.max(0, Math.min(rect.right, vw) - Math.max(rect.left, 0));
    var y = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
    return (x * y) / Math.max(1, rect.width * rect.height) >= 0.35;
  }

  function visibilityScore(video){
    if (!video || !video.isConnected) return 0;
    if (!autoplayAllowed(video)) return 0;
    if (modalOwner && !isOverlayMedia(video)) return 0;
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 1;
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    var x = Math.max(0, Math.min(rect.right, vw) - Math.max(rect.left, 0));
    var y = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
    var ratio = (x * y) / Math.max(1, rect.width * rect.height);
    if (ratio < 0.35) return 0;
    var center = rect.top + (rect.height / 2);
    var centerBias = 1 - Math.min(1, Math.abs(center - (vh / 2)) / Math.max(1, vh / 2));
    return ratio + (centerBias * 0.08);
  }

  function cleanupVideos(){
    videos.forEach(function(meta, video){
      if (!video || !video.isConnected) {
        if (observer && video) {
          try { observer.unobserve(video); } catch(e){}
        }
        videos.delete(video);
        if (activeVideo === video) {
          activeVideo = null;
          activeOwner = '';
        }
      }
    });
  }

  function bestVisibleVideo(){
    var best = null;
    var bestScore = 0;
    cleanupVideos();
    videos.forEach(function(meta, video){
      var score = visibilityScore(video);
      if (score > bestScore) {
        best = video;
        bestScore = score;
      }
    });
    return best;
  }

  function requestAutoplay(video, meta){
    if (video && meta) videos.set(video, Object.assign({}, videos.get(video) || {}, meta || {}));
    if (pendingAutoplayFrame) return;
    pendingAutoplayFrame = window.requestAnimationFrame(function(){
      pendingAutoplayFrame = null;
      var candidate = bestVisibleVideo();
      if (!candidate) return;
      var now = Date.now();
      var last = lastAutoplayAttempt.get(candidate) || 0;
      if (candidate === activeVideo && !candidate.paused && now - last < AUTOPLAY_COOLDOWN_MS) return;
      lastAutoplayAttempt.set(candidate, now);
      maybeAutoplay(candidate, videos.get(candidate) || {});
    });
  }

  function maybeAutoplay(video, meta){
    if (!video || !isVisible(video)) return Promise.resolve(false);
    return setActive(video, meta).then(function(){
      if (video.readyState < 2 && video.preload === 'none') video.preload = 'metadata';
      var preferredMuted = mutedPreference();
      return safePlay(video, preferredMuted).then(function(ok){
        if (!ok && !preferredMuted) return safePlay(video, true);
        return ok;
      });
    });
  }

  function initObserver(){
    if (observer || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          requestAutoplay(video, videos.get(video) || {});
        } else {
          if (activeVideo === video) pause(video, 'viewport-exit');
          if (!isOverlayMedia(video)) video.preload = 'none';
        }
      });
    }, { threshold: [0, 0.35, 0.65, 1] });
  }

  function register(video, meta){
    if (!video || video.tagName !== 'VIDEO') return null;
    normalize(video, meta || {});
    videos.set(video, Object.assign({}, videos.get(video) || {}, meta || {}));
    if (!registered.has(video)) {
      registered.add(video);
      initObserver();
      if (observer) observer.observe(video);
      ['pointerdown', 'touchstart', 'mousedown'].forEach(function(type){
        video.addEventListener(type, function(){ userGestureState.set(video, { at: Date.now(), wasPaused: !!video.paused }); }, { passive: true });
      });
      video.addEventListener('keydown', function(event){
        if (event.key === 'Enter' || event.key === ' ') userGestureState.set(video, { at: Date.now(), wasPaused: !!video.paused });
      });
      video.addEventListener('play', function(){
        var gesture = userGestureState.get(video) || {};
        var explicitPlay = Date.now() - Number(gesture.at || 0) < 1600 && gesture.wasPaused === true;
        if (explicitPlay) manualPauseState.set(video, false);
        var drawerKind = drawerVideoKind(video);
        if (explicitPlay && drawerKind) setCommentDrawerPriority(drawerKind);
        if (activeVideo && activeVideo !== video) pause(activeVideo, 'native-play');
        activeVideo = video;
        activeOwner = ownerFor(video, videos.get(video) || {});
        video.classList.add('dsd-gmor-active');
      }, true);
      video.addEventListener('pause', function(){
        var gesture = userGestureState.get(video) || {};
        if (Date.now() > Number(programmaticPauseUntil.get(video) || 0) &&
            Date.now() - Number(gesture.at || 0) < 1600 &&
            gesture.wasPaused === false) {
          manualPauseState.set(video, true);
        }
        video.classList.remove('dsd-gmor-active');
      }, true);
      video.addEventListener('volumechange', function(){
        if (Date.now() <= Number(muteWriteSuppressedUntil.get(video) || 0)) return;
        setMutedPreference(!!video.muted, video);
      }, true);
      video.addEventListener('ended', function(){
        if (activeVideo === video) pause(video, 'ended');
      }, true);
      document.dispatchEvent(new CustomEvent('dsd:gmor:registered', { detail: { version: VERSION, surface: surfaceFor(video, meta || {}), owner: ownerFor(video, meta || {}) } }));
    }
    writeDomState();
    if (isVisible(video) && !modalOwner) requestAutoplay(video, meta || {});
    return video;
  }

  function scan(root){
    cleanupVideos();
    qsa('video, .dsd-media-frame--video video, [data-dsd-media-kind="video"] video, video.track-video-views[data-video-id]', root || document).forEach(function(video){
      register(video, { owner: video.getAttribute('data-dsd-media-owner') || 'GMORScan', surface: surfaceFor(video, {}) });
    });
    return snapshot();
  }

  function requestScan(root){
    if (pendingScanTimer) window.clearTimeout(pendingScanTimer);
    pendingScanTimer = window.setTimeout(function(){
      pendingScanTimer = null;
      scan(root || document);
      requestAutoplay();
    }, SCAN_DEBOUNCE_MS);
  }

  function requestViewportAutoplay(){
    if (pendingViewportTimer) window.clearTimeout(pendingViewportTimer);
    pendingViewportTimer = window.setTimeout(function(){
      pendingViewportTimer = null;
      scan(document);
      requestAutoplay();
    }, VIEWPORT_DEBOUNCE_MS);
  }

  function unlockMediaSession(){
    mediaUnlocked = true;
    document.documentElement.setAttribute('data-dsd-media-unlocked', 'true');
    writeDomState();
  }

  function bindUnlock(){
    ['pointerdown','touchstart','click','keydown'].forEach(function(type){
      document.addEventListener(type, unlockMediaSession, { capture:true, passive:true });
    });
  }

  function claimModal(owner){
    modalOwner = owner || 'modal';
    if (activeVideo && !isOverlayMedia(activeVideo)) {
      modalResumeCandidate = activeVideo;
      modalResumeWasPlaying = !activeVideo.paused && !activeVideo.ended;
      pause(activeVideo, 'modal-opened');
    }
    document.documentElement.setAttribute('data-dsd-gmor-modal-owner', modalOwner);
    writeDomState();
  }

  function releaseModal(owner){
    if (!owner || owner === modalOwner) modalOwner = '';
    if (!modalOwner) document.documentElement.removeAttribute('data-dsd-gmor-modal-owner');
    writeDomState();
    if (!modalOwner) {
      var candidate = modalResumeCandidate;
      var shouldResume = !!(modalResumeWasPlaying && candidate && candidate.isConnected && !isManualPaused(candidate));
      modalResumeCandidate = null;
      modalResumeWasPlaying = false;
      window.setTimeout(function(){
        if (shouldResume && !modalOwner && isVisible(candidate)) {
          maybeAutoplay(candidate, videos.get(candidate) || {});
        }
      }, 80);
    }
  }

  function toggle(video, meta){
    if (!video) return Promise.resolve(false);
    register(video, meta || {});
    if (video.paused || video.ended) {
      manualPauseState.set(video, false);
      return setActive(video, meta || {}).then(function(){ return safePlay(video, mutedPreference()); });
    }
    manualPauseState.set(video, true);
    pause(video, 'user-toggle');
    return Promise.resolve(true);
  }

  function pauseActive(reason){
    if (activeVideo) pause(activeVideo, reason || 'pause-active');
  }

  function snapshot(){
    return {
      version: VERSION,
      recoveredFrom: SOURCE,
      registered: videos.size,
      activeOwner: activeOwner,
      activeSurface: activeVideo ? surfaceFor(activeVideo, videos.get(activeVideo) || {}) : '',
      activePaused: activeVideo ? activeVideo.paused : true,
      activeVisible: activeVideo ? isVisible(activeVideo) : false,
      pendingAutoplay: !!pendingAutoplayFrame,
      mediaUnlocked: mediaUnlocked,
      modalOwner: modalOwner
    };
  }

  function writeDomState(){
    if (!document.documentElement) return;
    var root = document.documentElement;
    root.setAttribute('data-dsd-gmor', 'active');
    root.setAttribute('data-dsd-gmor-version', VERSION);
    root.setAttribute('data-dsd-gmor-source', SOURCE);
    root.setAttribute('data-dsd-gmor-registered', String(videos.size));
    root.setAttribute('data-dsd-gmor-active-owner', activeOwner || '');
    root.setAttribute('data-dsd-gmor-active-surface', activeVideo ? surfaceFor(activeVideo, videos.get(activeVideo) || {}) : '');
    root.setAttribute('data-dsd-gmor-active-visible', activeVideo && isVisible(activeVideo) ? 'true' : 'false');
    root.setAttribute('data-dsd-gmor-pending-autoplay', pendingAutoplayFrame ? 'true' : 'false');
    root.setAttribute('data-dsd-gmor-unlocked', mediaUnlocked ? 'true' : 'false');
    root.setAttribute('data-dsd-gmor-modal-owner', modalOwner || '');
  }

  function boot(){
    if (booted) return;
    booted = true;
    claimRuntime();
    bindUnlock();
    scan(document);
    if ('MutationObserver' in window) {
      mutationObserver = new MutationObserver(function(records){
        var needsScan = records.some(function(record){
          return Array.prototype.some.call(record.addedNodes || [], function(node){
            return node && node.nodeType === 1 && (node.tagName === 'VIDEO' || (node.querySelector && node.querySelector('video,[data-dsd-media-kind="video"]')));
          });
        });
        if (needsScan) requestScan(document);
      });
      mutationObserver.observe(document.documentElement, { childList:true, subtree:true });
    }
    document.addEventListener('visibilitychange', function(){ if (document.hidden) pauseActive('document-hidden'); else requestViewportAutoplay(); });
    window.addEventListener('scroll', requestViewportAutoplay, { passive:true });
    window.addEventListener('resize', requestViewportAutoplay, { passive:true });
    document.addEventListener('shopify:section:load', function(event){ scan(event.target || document); });
    document.addEventListener('dsd:modal-opened', function(){ claimModal('dsd-modal'); });
    document.addEventListener('dsd:modal-closed', function(){ releaseModal('dsd-modal'); });
  }

  window.DSDGMOR = {
    version: VERSION,
    register: register,
    registerAll: scan,
    scan: scan,
    primeCounts: function(){ return snapshot(); },
    loadNextProfileChunk: function(){ return false; },
    toggle: toggle,
    pauseVideo: pause,
    isManualPaused: isManualPaused,
    mutedPreference: mutedPreference,
    setActive: setActive,
    pauseActive: pauseActive,
    claimModal: claimModal,
    releaseModal: releaseModal,
    setCommentDrawerPriority: setCommentDrawerPriority,
    clearCommentDrawerPriority: clearCommentDrawerPriority,
    unlock: unlockMediaSession,
    snapshot: snapshot
  };
  window.DSDMedia = window.DSDGMOR;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  boot();
})();
